import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import { jwtDecode } from 'jwt-decode';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
        globalCharacters: null,
        globalScales:null,  
        glb_appointments: null,
        appointmentInterval: null,
  },
  mutations: {
    SET_GLOBAL_CHARACTERS(state, characters) {
        state.globalCharacters = characters
    },
    SET_GLOBAL_SCALES(state, scales) {
        state.globalScales = scales
    },    
    SET_GLOBAL_APPOINTMENTS(state, appointments) {
      state.glb_appointments = appointments
    },
    SET_APPOINTMENT_INTERVAL(state, interval) {
      state.appointmentInterval = interval
    }
  },
    actions: {
        async fetchGlobalScales({ commit,state }) {
            if (state.globalScales && state.globalScales.length > 0) {
                return;
            }
            try {
                const response = await axios.get('/scale-api/v1/get_all_data')
                if (response.data.code === '00' || response.data.code == 200) {
                    var strRes = response.data.result;
                    var scaleList = JSON.parse(strRes);//TODO                        
                    if (scaleList && scaleList.length > 0) {
                        commit('SET_GLOBAL_SCALES', scaleList);
                    } else {
                        throw new Error('获取的量表列表为空');
                    }
                } else {
                    throw new Error(response.data.message || '获取量表失败');
                }
            } catch (error) {
                console.error('获取量表失败:', error);
                throw error;
            }
        },
        async fetchGlobalCharacters({ commit }) {
          const token = localStorage.getItem('token')
          if (!token) {
            return
          }

          try {
            const response = await axios.get('/api/character/list', {
              headers: {
                'Authorization': `Bearer ${token}`
              }
            })

            if (response.data.code === '00') {
              commit('SET_GLOBAL_CHARACTERS', response.data.characterList)
            }
          } catch (error) {
            console.error('获取角色列表失败:', error)
          }
        },
        isInExpired() {
            const token = localStorage.getItem('token')
            if (!token) {
                return false;
            }
            try {
                const decodedToken = jwtDecode(token);
                const currentTime = Date.now() / 1000;
                if (decodedToken.exp < currentTime) {
                    localStorage.removeItem('token');
                    return false;
                }
                return true;
            } catch (e) {
                console.log(e);
                return false;
            }
        },
        async fetchAppointments({ commit, dispatch }) {
            const token = localStorage.getItem('token')
            if (!token) {
                return;
            }
            if (!dispatch('isInExpired')) {
                return;
            }
            const payload = {
                curpage: 1,
                state:"create"
            };
          try {
              const response = await axios.post('/api/reservation/list', payload, {
                  headers: {
                      'Authorization': `Bearer ${token}`
                  }
              });
    
            if (response.data.code === '00') {
                  commit('SET_GLOBAL_APPOINTMENTS', response.data.infos)
            }
          } catch (error) {
                console.error('获取预约列表失败:', error)
          }
        },
        startAppointmentPolling({ commit, dispatch }) {
          // 先立即执行一次
          dispatch('fetchAppointments');
          const interval = setInterval(() => {
            dispatch('fetchAppointments');
          }, 30 * 60 * 1000); 
          
          commit('SET_APPOINTMENT_INTERVAL', interval);
        },
        stopAppointmentPolling({ commit, state }) {
          if (state.appointmentInterval) {
            clearInterval(state.appointmentInterval);
            commit('SET_APPOINTMENT_INTERVAL', null);
          }
        }
  },
  getters: {
      getGlobalCharacters: state => state.globalCharacters,
      getGlobalScales: state => state.globalScales,
      getGlobalAppointments: state => state.glb_appointments,  
  }
})